import { useEffect, useState } from 'react';

import { client, useErrorNotifications } from 'core/http';

type SurfaceReport = {
  data: Array<any>;
  meta: Array<any>;
};

type Params = {
  size?: string;
  vehicle_type_id?: string;
  traffic_id?: number;
};

export default function useSurfaceReports(params: Params) {
  const showErrorNotification = useErrorNotifications();
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState({
    data: [],
    meta: []
  } as SurfaceReport);

  useEffect(() => {
    if (!params.size) {
      return;
    }

    setLoading(true);

    client()
      .get('surfaces/reports', { params })
      .then(response => setReports(response.data))
      .catch(showErrorNotification)
      .finally(() => setLoading(false));
  }, [params, showErrorNotification]);

  return { reports, loading };
}
